/* ══════════════════════════════════════
   Monmouth Cards — Product Detail Page JS
   assets/monmouth-pdp.js
   ══════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Gallery Thumbnails ── */
  var thumbs  = document.querySelectorAll('.mc-pdp__thumb');
  var mainImg = document.querySelector('.mc-pdp__gallery-main img');

  thumbs.forEach(function (thumb) {
    /* ENG-07: thumbnails are <button type="button">, so Enter/Space fire click natively */
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) {
        t.classList.remove('mc-pdp__thumb--active');
        t.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('mc-pdp__thumb--active');
      thumb.setAttribute('aria-current', 'true');
      if (mainImg && thumb.dataset.src) {
        mainImg.src     = thumb.dataset.src;
        mainImg.srcset  = thumb.dataset.srcset || '';
        if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
      }
    });
  });

  /* ── Quantity Stepper ── */
  var qtyInput = document.querySelector('.mc-pdp__qty-input');
  var qtyMinus = document.querySelector('.mc-pdp__qty-btn[data-action="minus"]');
  var qtyPlus  = document.querySelector('.mc-pdp__qty-btn[data-action="plus"]');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      var max = parseInt(qtyInput.getAttribute('max')) || 99;
      qtyInput.value = Math.min(max, val + 1);
    });
  }

  /* ── Variant Selector ──
     Real fix (pdp-variant-wrong-item-bug-prompt.md) — this used to just
     overwrite the hidden `id` input with whatever single variant ID was
     baked into the clicked button, with no concept of "Size=Large AND
     Color=Blue selected together." On any product with 2+ option axes,
     whichever button was clicked LAST won using its own baked-in ID, which
     for many real combinations was a genuinely wrong variant — sometimes
     with no click order that reached the correct one at all. Fix: track
     the customer's selection per axis, and re-resolve the exact matching
     variant from the full embedded variant list on every click, instead of
     trusting a value baked into one button ahead of time. */
  var variantBtns    = document.querySelectorAll('.mc-pdp__variant');
  var variantInput   = document.getElementById('mc-pdp-variant-id');
  var priceEl        = document.querySelector('.mc-pdp__price');
  var stickyPrice    = document.querySelector('.mc-pdp__sticky-bar-price');
  var skuEl          = document.getElementById('mc-pdp-sku-value');
  var variantsDataEl = document.getElementById('mc-pdp-variants-data');
  var initialSelEl   = document.getElementById('mc-pdp-initial-selection');
  var configEl       = document.getElementById('mc-pdp-config');

  if (variantBtns.length && variantsDataEl && initialSelEl) {
    var mcVariants = [];
    var mcSelection = [];
    var mcConfig = {};
    try {
      mcVariants  = JSON.parse(variantsDataEl.textContent) || [];
      mcSelection = JSON.parse(initialSelEl.textContent) || [];
      mcConfig    = configEl ? (JSON.parse(configEl.textContent) || {}) : {};
    } catch (e) { mcVariants = []; mcSelection = []; mcConfig = {}; }

    var noteEl = document.getElementById('mc-pdp-variant-note');

    function mcFindVariant(selection) {
      for (var i = 0; i < mcVariants.length; i++) {
        var v = mcVariants[i];
        var isMatch = true;
        for (var axis = 0; axis < selection.length; axis++) {
          if (v.options[axis] !== selection[axis]) { isMatch = false; break; }
        }
        if (isMatch) return v;
      }
      return null;
    }

    /* How many of the OTHER option choices a variant shares with the current selection */
    function mcOverlap(v, axisIndex) {
      var n = 0;
      for (var i = 0; i < mcSelection.length; i++) {
        if (i !== axisIndex && v.options[i] === mcSelection[i]) n++;
      }
      return n;
    }
    function mcBest(list, axisIndex) {
      var best = null, bestScore = -1;
      list.forEach(function (v) {
        var sc = mcOverlap(v, axisIndex);
        if (sc > bestScore) { best = v; bestScore = sc; }
      });
      return best;
    }

    /* ENG-05: picking an option never dead-ends. The shopper's other choices are kept when that exact combination exists
       (even if it is sold out: it is then shown as sold out, truthfully). When it does not exist, the other options move
       to the nearest combination that has this value (preferring one that is in stock). */
    function mcPick(axisIndex, value) {
      var cand = mcSelection.slice();
      cand[axisIndex] = value;
      var exact = mcFindVariant(cand);
      if (exact) return { variant: exact, switched: false, wanted: cand };
      var pool = mcVariants.filter(function (v) { return v.options[axisIndex] === value; });
      var avail = pool.filter(function (v) { return v.available; });
      var pick = mcBest(avail.length ? avail : pool, axisIndex);
      return { variant: pick, switched: true, wanted: cand };
    }

    function mcRefreshButtonStates() {
      variantBtns.forEach(function (b) {
        var axisIndex = parseInt(b.dataset.optionIndex, 10);
        var value = b.dataset.optionValue;

        var isActive = mcSelection[axisIndex] === value;
        b.classList.toggle('mc-pdp__variant--active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var candidate = mcSelection.slice();
        candidate[axisIndex] = value;
        var candidateVariant = mcFindVariant(candidate);
        var unavailable = !candidateVariant || candidateVariant.available === false;
        b.classList.toggle('mc-pdp__variant--unavailable', unavailable);
        b.title = unavailable ? (candidateVariant ? 'Sold out with your other choices' : 'Not offered with your other choices: selecting it will change them') : '';
        if (candidateVariant) b.dataset.price = candidateVariant.price;
      });
    }

    function mcSetText(el, text) { if (el && el.textContent !== text) el.textContent = text; }

    /* ENG-06: ONE place that draws everything that depends on the selected variant: price, compare-at price, saving badge,
       gallery badge, main image, stock text, Add to Cart button (main and sticky), SKU, shipping/inventory label, URL. All of
       it comes from the variant data embedded by the section, never from the previous state of the page. */
    function mcRenderVariant(variant, opts) {
      if (!variant) return;
      opts = opts || {};

      /* hidden ids sent to the cart */
      if (variantInput) variantInput.value = variant.id;
      var stickyInput = document.querySelector('.mc-pdp__sticky-bar input[name="id"]');
      if (stickyInput) stickyInput.value = variant.id;

      /* price, compare-at price, saving badge (numbers stay in cents; formatted text comes with the data) */
      var onSale = variant.compare_at_cents > variant.price_cents;
      var savePct = onSale ? Math.round((variant.compare_at_cents - variant.price_cents) * 100 / variant.compare_at_cents) : 0;
      if (priceEl) { mcSetText(priceEl, variant.price); priceEl.classList.toggle('mc-pdp__price--sale', onSale); }
      if (stickyPrice) mcSetText(stickyPrice, variant.price);
      var cmpEl = document.querySelector('.mc-pdp__price-compare');
      var saveEl = document.querySelector('.mc-pdp__save-badge');
      if (cmpEl) { cmpEl.hidden = !onSale; if (onSale) mcSetText(cmpEl, variant.compare_at); }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) mcSetText(saveEl, 'Save ' + savePct + '%'); }

      /* gallery badge: same priority as the page's first render */
      var badge = document.querySelector('.mc-pdp__gallery-badge');
      if (badge) {
        if (!variant.available) {
          badge.className = 'mc-pdp__gallery-badge'; badge.style.cssText = 'background:var(--mc-gray-400);color:#fff;'; badge.hidden = false; badge.textContent = 'Sold Out';
        } else {
          badge.style.cssText = '';
          if (mcConfig.preorder) { badge.className = 'mc-pdp__gallery-badge mc-pdp__gallery-badge--preorder'; badge.textContent = 'Pre-Order'; badge.hidden = false; }
          else if (mcConfig.mystery) { badge.className = 'mc-pdp__gallery-badge mc-pdp__gallery-badge--hot'; badge.textContent = 'Mystery'; badge.hidden = false; }
          else if (onSale) { badge.className = 'mc-pdp__gallery-badge mc-pdp__gallery-badge--sale'; badge.textContent = savePct + '% Off'; badge.hidden = false; }
          else if (mcConfig.isNew) { badge.className = 'mc-pdp__gallery-badge mc-pdp__gallery-badge--new'; badge.textContent = 'New'; badge.hidden = false; }
          else { badge.hidden = true; badge.textContent = ''; }
        }
      }

      /* main image: only when the variant has its own image (otherwise the current picture stays) */
      if (variant.image && mainImg && variant.image.src) {
        if (mainImg.getAttribute('src') !== variant.image.src) {
          mainImg.src = variant.image.src;
          if (variant.image.srcset) mainImg.srcset = variant.image.srcset;
          if (variant.image.alt) mainImg.alt = variant.image.alt;
          if (variant.image.width) mainImg.setAttribute('width', variant.image.width);
          if (variant.image.height) mainImg.setAttribute('height', variant.image.height);
        }
        document.querySelectorAll('.mc-pdp__thumb').forEach(function (t) {
          var on = String(t.dataset.imageId) === String(variant.image.id);
          t.classList.toggle('mc-pdp__thumb--active', on);
          if (t.tagName === 'BUTTON') t.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      /* stock text */
      var stockEl = document.getElementById('mc-pdp-stock');
      var stockTxt = document.getElementById('mc-pdp-stock-text');
      if (stockEl && stockTxt) {
        var kind = !variant.available ? 'out' : (mcConfig.preorder ? 'preorder' : 'in');
        stockEl.classList.remove('mc-pdp__stock--in', 'mc-pdp__stock--out', 'mc-pdp__stock--preorder');
        stockEl.classList.add('mc-pdp__stock--' + kind);
        mcSetText(stockTxt, kind === 'out' ? (mcConfig.outText || 'Sold Out') : (kind === 'preorder' ? mcConfig.preText : mcConfig.inText));
      }

      /* Add to Cart (main form) */
      var addBtn = document.querySelector('.mc-pdp__add-btn');
      if (addBtn) {
        if (!variant.available) {
          addBtn.type = 'button'; addBtn.disabled = true;
          addBtn.classList.add('mc-pdp__add-btn--soldout'); addBtn.classList.remove('mc-pdp__add-btn--preorder');
          mcSetText(addBtn, 'Sold Out');
        } else {
          addBtn.type = 'submit'; addBtn.disabled = false;
          addBtn.classList.remove('mc-pdp__add-btn--soldout');
          addBtn.classList.toggle('mc-pdp__add-btn--preorder', !!mcConfig.preorder);
          mcSetText(addBtn, (mcConfig.preorder ? 'Pre-Order' : 'Add to Cart') + ' — ' + variant.price);
        }
      }
      /* Sticky bar button + dynamic checkout follow the same availability */
      var stickyBtn = document.querySelector('[data-mc-sticky-btn]');
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        mcSetText(stickyBtn, !variant.available ? 'Sold Out' : (mcConfig.preorder ? 'Pre-Order' : 'Add to Cart'));
      }
      var payWrap = document.querySelector('.mc-pdp__shopify-payment');
      if (payWrap) payWrap.hidden = !variant.available;

      if (skuEl) skuEl.textContent = variant.sku || 'N/A';

      /* shipping / inventory label from the selected variant's own stock */
      if (typeof window.mcApplyWarehouseLabel === 'function') window.mcApplyWarehouseLabel(variant.inventory_quantity);

      if (!opts.initial && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    function mcShowNote(text) {
      if (!noteEl) return;
      if (!text) { noteEl.hidden = true; noteEl.textContent = ''; return; }
      noteEl.textContent = text; noteEl.hidden = false;
      if (typeof window.mcAnnounce === 'function') window.mcAnnounce(text);
    }

    /* Initial render may have picked a button as --active/--unavailable
       purely from current_variant's own combination at page load — refresh
       once up front so state is consistent with this same JS logic, and draw the
       selected variant once (sticky bar, payment button, ...) so a direct
       ?variant=<sold-out id> link is as truthful as a click. */
    mcRefreshButtonStates();
    var mcInitial = mcFindVariant(mcSelection);
    if (mcInitial) mcRenderVariant(mcInitial, { initial: true });

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var axisIndex = parseInt(btn.dataset.optionIndex, 10);
        var res = mcPick(axisIndex, btn.dataset.optionValue);
        if (!res.variant) return;
        mcSelection = res.variant.options.slice();
        mcRenderVariant(res.variant);
        mcRefreshButtonStates();
        if (res.switched) {
          mcShowNote('“' + res.wanted.join(' / ') + '” isn’t offered, so we selected “' + res.variant.options.join(' / ') + '”' + (res.variant.available ? '.' : ' (sold out).'));
        } else if (!res.variant.available) {
          mcShowNote('This combination is sold out.');
        } else {
          mcShowNote('');
        }
      });
    });
  }

  /* Real race-condition fix (referral-code-race-condition-add-to-cart-
     prompt.md) — reads the mc_ref_code cookie set by layout/theme.liquid
     and returns it as a cart-attributes fragment to merge into a /cart/
     add.js call, so the code lands in the SAME request that adds the
     item instead of racing a separate background sync call. This is the
     main product page's Add to Cart — the exact call site involved in
     the confirmed live race (order #1041/#1042). */
  function mcGetReferralAttribute() {
    var m = document.cookie.match(/(?:^|; )mc_ref_code=([^;]*)/);
    return m ? { mc_ref_code: decodeURIComponent(m[1]) } : {};
  }

  /* Real fix (rip-and-ship-pdp-integration-prompt.md) — this AJAX submit
     rebuilt its own {id, quantity} body from scratch instead of reading the
     form, so any properties[...] input (Rip & Ship's 4 hidden fields, or
     anything future added the same way) was silently dropped even when
     correctly enabled. Only enabled inputs are read — a disabled one is
     never submitted, same as a native form post. */
  function mcGetLineItemProperties(form) {
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if (el.disabled) return;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = el.value;
    });
    return props;
  }

  /* ── AJAX Add to Cart ── */
  function ajaxAddToCart(form, btn) {
    var variantId = form.querySelector('[name="id"]').value;
    var quantity  = parseInt((form.querySelector('[name="quantity"]') || {}).value || 1);
    var original  = btn.textContent;

    btn.textContent = 'Adding…';
    btn.disabled    = true;

    /* Open the drawer right away with a placeholder line (the real line replaces it when the add answers). */
    var pdpTitleEl = document.querySelector('h1');
    var pdpImgEl = document.querySelector('.mc-pdp__gallery img, .mc-pdp img, main img');
    document.dispatchEvent(new CustomEvent('mc:cart-adding', { detail: {
      title: pdpTitleEl ? pdpTitleEl.textContent.trim() : '',
      image: pdpImgEl ? (pdpImgEl.currentSrc || pdpImgEl.src) : ''
    } }));

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: quantity, properties: mcGetLineItemProperties(form), attributes: mcGetReferralAttribute() })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          /* Shopify returned an error object (sold out / not enough stock): drop the placeholder, close the drawer. */
          document.dispatchEvent(new CustomEvent('mc:cart-add-failed'));
          btn.textContent = data.description || 'Error';
          btn.disabled    = false;
          setTimeout(function () { btn.textContent = original; }, 2500);
          return;
        }
        btn.textContent = '✓ Added!';
        try { sessionStorage.setItem('mc_last_added_variant_id', String(data.variant_id || variantId)); } catch (e) { /* no-op */ }

        /* Draw the added line + update the badge straight from the add response (no extra round trip) */
        document.dispatchEvent(new CustomEvent('mc:cart-added', { detail: { item: data } }));
        /* Tell cart.js to reconcile with the real cart (one shared /cart.js request) */
        document.dispatchEvent(new CustomEvent('mc:cart-updated'));
        /* Open the cart drawer (no-op: the click already opened it) */
        document.dispatchEvent(new CustomEvent('mc:open-cart-drawer'));

        /* Analytics: fire add_to_cart (helper defined in monmouth-integrations), after the drawer has rendered and
           never blocking it. */
        setTimeout(function () {
          try {
            if (window.mcTrack && typeof window.mcTrack.addToCart === 'function') {
              window.mcTrack.addToCart({
                id: data.product_id || variantId,
                title: data.product_title || data.title,
                price: (typeof data.price === 'number' ? data.price / 100 : undefined)
              }, quantity);
            }
          } catch (e) { /* no-op */ }
        }, 0);

        setTimeout(function () {
          btn.textContent = original;
          btn.disabled    = false;
        }, 1600);
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('mc:cart-add-failed'));
        btn.textContent = 'Error — try again';
        btn.disabled    = false;
        setTimeout(function () { btn.textContent = original; }, 2500);
      });
  }

  /* Main add-to-cart form */
  var addForm = document.querySelector('.mc-pdp__add-form');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = addForm.querySelector('.mc-pdp__add-btn');
      if (submitBtn && !submitBtn.disabled) ajaxAddToCart(addForm, submitBtn);
    });
  }

  /* Sticky ATC bar form */
  var stickyForm = document.querySelector('.mc-pdp__sticky-bar form');
  if (stickyForm) {
    stickyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = stickyForm.querySelector('.mc-pdp__sticky-bar-btn');
      if (submitBtn) ajaxAddToCart(stickyForm, submitBtn);
    });
  }

  /* ── Description Tabs ── */
  var tabs = document.querySelectorAll('.mc-pdp__tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.tab;
      tabs.forEach(function (t) { t.classList.remove('mc-pdp__tab--active'); });
      document.querySelectorAll('.mc-pdp__tab-panel').forEach(function (p) {
        p.classList.remove('mc-pdp__tab-panel--active');
      });
      tab.classList.add('mc-pdp__tab--active');
      var panel = document.getElementById('mc-tab-' + target);
      if (panel) panel.classList.add('mc-pdp__tab-panel--active');
    });
  });

  /* ── Accordion Toggle (ENG-09: aria-expanded / aria-controls / region ids kept in sync) ── */
  document.querySelectorAll('.mc-pdp__accordion').forEach(function (acc, i) {
    var header = acc.querySelector('.mc-pdp__accordion-header');
    var body   = acc.querySelector('.mc-pdp__accordion-body');
    if (!header || !body) return;
    var hid = header.id || ('mc-acc-btn-' + i);
    var bid = body.id || ('mc-acc-panel-' + i);
    header.id = hid;
    body.id = bid;
    header.setAttribute('aria-controls', bid);
    header.setAttribute('aria-expanded', acc.classList.contains('mc-pdp__accordion--open') ? 'true' : 'false');
    body.setAttribute('role', 'region');
    body.setAttribute('aria-labelledby', hid);
    header.addEventListener('click', function () {
      var open = acc.classList.toggle('mc-pdp__accordion--open');
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ── Sticky ATC Bar (show on scroll past main ATC) ── */
  var stickyBar      = document.querySelector('.mc-pdp__sticky-bar');
  var addToCartBlock = document.querySelector('.mc-pdp__actions');

  if (stickyBar && addToCartBlock) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('mc-pdp__sticky-bar--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(addToCartBlock);
  }

  /* ── Related Products ──
     Real fix (search-engine-visibility-prompt.md part 6) — the section
     used to gate on `recommendations.performed`, which nothing in this
     theme ever makes true (that only fires when Shopify itself renders
     this section through its Section Rendering API recommendations
     endpoint). Uses Shopify's simpler JSON recommendations endpoint
     instead, which needs no special wiring, and renders into the same
     .mc-pdp__related-grid the old code targeted — same card markup/
     classes as snippets/monmouth-product-card.liquid so it's styled
     identically to every other product card on the site. */
  function mcMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function mcEscHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mcRenderRelatedCard(p) {
    var variants = p.variants || [];
    var firstVariant = variants[0];
    var isSale = firstVariant && firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price;
    var titleEsc = mcEscHtml(p.title);
    var img = p.featured_image || (p.images && p.images[0]) || '';

    var actionHtml;
    if (p.available === false) {
      actionHtml = '<button class="mc-product-card__btn mc-product-card__btn--soldout" disabled>Sold Out</button>';
    } else if (variants.length === 1 && firstVariant) {
      actionHtml =
        '<form method="post" action="/cart/add">' +
          '<input type="hidden" name="id" value="' + firstVariant.id + '">' +
          '<button type="submit" class="mc-product-card__btn">Add to Cart</button>' +
        '</form>';
    } else {
      actionHtml = '<a href="' + p.url + '" class="mc-product-card__btn">Select Options</a>';
    }

    return (
      '<div class="mc-product-card">' +
        '<a href="' + p.url + '" class="mc-product-card__img-link">' +
          '<div class="mc-product-card__img">' +
            (img
              ? '<img src="' + img + '" alt="' + titleEsc + '" width="200" height="280" loading="lazy" class="mc-product-card__image">'
              : '') +
            (p.available === false
              ? '<span class="mc-product-card__badge mc-badge mc-badge--soldout">Sold Out</span>'
              : (isSale ? '<span class="mc-product-card__badge mc-badge mc-badge--sale">Sale</span>' : '')) +
          '</div>' +
        '</a>' +
        '<div class="mc-product-card__body">' +
          '<a href="' + p.url + '" class="mc-product-card__title" title="' + titleEsc + '">' + titleEsc + '</a>' +
          '<div class="mc-product-card__price' + (isSale ? ' mc-product-card__price--sale' : '') + '">' +
            '<span class="mc-product-card__price-current">' + mcMoney(p.price) + '</span>' +
            (isSale ? '<span class="mc-product-card__price-compare">' + mcMoney(firstVariant.compare_at_price) + '</span>' : '') +
          '</div>' +
          actionHtml +
        '</div>' +
      '</div>'
    );
  }

  var relatedEl = document.getElementById('mc-pdp-related');
  if (relatedEl) {
    var relatedProductId = relatedEl.dataset.productId;
    var relatedLimit = parseInt(relatedEl.dataset.limit, 10) || 4;
    var relatedGrid = document.getElementById('mc-pdp-related-grid');

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(relatedProductId) + '&limit=' + relatedLimit + '&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        /* Real fix (pre-launch-remaining-fixes-prompt.md, Part 4) — this
           only ever excluded the current product's own id; a sold out
           recommended product still rendered with a "Sold Out" badge
           instead of being left out, unlike every other product grid on
           the site. */
        var products = ((data && data.products) || []).filter(function (p) {
          return String(p.id) !== String(relatedProductId) && p.available !== false;
        });
        if (!products.length || !relatedGrid) return;
        relatedGrid.innerHTML = products.map(mcRenderRelatedCard).join('');
        relatedEl.hidden = false;
      })
      .catch(function () { /* fail quietly — no empty state, no error message */ });
  }

})();

/* ==========================================================================
   RIP & SHIP
   snippets/monmouth-rip-and-ship.liquid
   ==========================================================================
   Three jobs:
     1. Enable/disable the hidden line item property inputs. A DISABLED input
        is not submitted with the form, so "ship sealed" posts nothing and
        the order stays clean. Selecting Rip & Ship enables them.
     2. Live countdown to the order cutoff, so the customer can see the
        deadline rather than discovering it at checkout.
     3. Close the option when the cutoff passes mid-session — someone can sit
        on a PDP for an hour, and we must not take an order for a stream
        that has stopped accepting them.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mcRipShipInit) return;
  window.__mcRipShipInit = true;

  function init() {
    var root = document.querySelector('[data-mc-rip-ship]');
    if (!root) return;

    var inputs = root.querySelectorAll('[data-mc-rs-input]');
    var props  = root.querySelectorAll('[data-mc-rs-prop]');
    var terms  = root.querySelector('[data-mc-rs-terms]');
    var note   = root.querySelector('[data-mc-rs-countdown]');
    var addBtn = document.querySelector('.mc-pdp__add-btn');
    var addBtnDefaultText = addBtn ? addBtn.textContent : '';

    function apply(choice) {
      var ripping = choice === 'rip';

      /* Disabled inputs don't post. This is the whole mechanism. */
      props.forEach(function (el) { el.disabled = !ripping; });

      root.querySelectorAll('.mc-rs__opt').forEach(function (label) {
        var radio = label.querySelector('[data-mc-rs-input]');
        label.classList.toggle('mc-rs__opt--active', !!(radio && radio.checked));
      });

      if (terms) terms.hidden = !ripping;

      if (addBtn && !addBtn.disabled) {
        addBtn.textContent = ripping
          ? addBtnDefaultText.replace('Add to Cart', 'Add to Cart — Rip & Ship')
          : addBtnDefaultText;
      }

      if (window.mcAnnounce) {
        window.mcAnnounce(ripping
          ? 'Rip and Ship selected. Your box will be opened live on stream.'
          : 'Ship sealed selected.');
      }
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', function () { apply(this.value); });
    });

    /* Keep the variant selector in sync — monmouth-pdp.js rewrites the ATC
       label when a variant changes, which would wipe our suffix. */
    var priceEl = document.querySelector('.mc-pdp__price');
    if (priceEl && 'MutationObserver' in window && addBtn) {
      new MutationObserver(function () {
        addBtnDefaultText = addBtn.textContent.replace(' — Rip & Ship', '');
        var checked = root.querySelector('[data-mc-rs-input]:checked');
        if (checked) apply(checked.value);
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* ── Cutoff countdown ── */
    if (note) {
      var startsAt = parseInt(note.getAttribute('data-starts'), 10) * 1000;
      var cutoffMs = parseInt(note.getAttribute('data-cutoff'), 10) * 1000;
      var closesAt = startsAt - cutoffMs;

      var tick = function () {
        var left = closesAt - Date.now();

        if (left <= 0) {
          /* Cutoff passed while they were on the page. Force sealed and
             close the option — never take an order we can't honour. */
          var ripRadio = root.querySelector('[data-mc-rs-input][value="rip"]');
          var sealed   = root.querySelector('[data-mc-rs-input][value="sealed"]');
          if (sealed) { sealed.checked = true; apply('sealed'); }
          if (ripRadio) {
            ripRadio.disabled = true;
            var lbl = ripRadio.closest('.mc-rs__opt');
            if (lbl) { lbl.style.opacity = '.5'; lbl.style.cursor = 'not-allowed'; }
          }
          note.textContent = 'Orders for this stream have closed. The next date will be posted shortly.';
          clearInterval(timer);
          return;
        }

        var hrs  = Math.floor(left / 3600000);
        var mins = Math.floor((left % 3600000) / 60000);

        if (hrs > 48) { note.textContent = ''; return; }
        if (hrs >= 1) { note.textContent = 'Order within ' + hrs + 'h ' + mins + 'm to make this stream'; }
        else          { note.textContent = 'Only ' + mins + ' minutes left to make this stream'; }
      };

      tick();
      var timer = setInterval(tick, 30000);

      /* Don't burn battery on a hidden tab. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearInterval(timer); }
        else { tick(); timer = setInterval(tick, 30000); }
      });
    }

    var initial = root.querySelector('[data-mc-rs-input]:checked');
    apply(initial ? initial.value : 'sealed');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
